import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Contact from "./Contact";
import "./ContactSection.scss";

function ContactSection(props) {
  const [selectedOption, setSelectedOption] = React.useState("AAI");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="ContactSection__container container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        />
        <div className="field">
          <label className="label">Interested in:</label>
          <div className="control">
            <div className="select">
              <select value={selectedOption} onChange={handleOptionChange}>
                <option value="AAI">Accountable AI</option>
                <option value="API">Developer/API integration</option>
                <option value="APP">App platform</option>
              </select>
            </div>
          </div>
        </div>
        <Contact
          showNameField={props.showNameField}
          buttonText={props.buttonText}
          buttonColor={props.buttonColor}
          buttonInverted={props.buttonInverted}
          selectedOption={selectedOption}
        />
      </div>
    </Section>
  );
}

export default ContactSection;
